import { makeStyles } from '@material-ui/core/styles';

export const useFormReaderRequestStyles = makeStyles(theme => ({
  formReaderRequest: {
    flexGrow: 1
  },
  tabsMinHeight: {
    minHeight: '22.1875rem'
  },
  containers: {
    padding: '24px 0px 16px 0px',
    alignItems: 'start',
    background: 'white',
    borderRadius: '4px'
  },
  chip: {
    '& .MuiChip-root': {
      backgroundColor: `${theme.palette.primary.light} !important`
    },
    '& .MuiChip-deleteIcon': {
      display: 'none'
    }
  }
}));
